import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

// Route guard: redirects to /login when signed out, or to / when signed in
// but not one of the allowed roles. Extracted out of App.js so this — the
// frontend's only RBAC enforcement point — is unit-testable in isolation.
export const RequireAuth = ({ children, roles = [] }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireAuth;
